export default __webpack_public_path__ + "static/1-0f6c7ea659f989f57fb3fd0a472ffb83.jpeg";